export const DEFAULT_TOGGLE_ON_COLOR = "#3977a2";
export const DENIED_COLOR = "#dc3545";
export const APPROVED_COLOR = "#28a745";
export const COMPLETE_COLOR = "#498ab2";
export const INCOMPLETE_COLOR = "#8e8e8e";
export const OBLIGATION_COLOR = "#FDB81E";
export const NO_DECISION_COLOR = "#ADB5BD";

export const VERY_HIGH_FRAUD_COLOR = "#8B0000";
export const HIGH_FRAUD_COLOR = "#E0310B";
export const MEDIUM_FRAUD_COLOR = "#FF8C00";
export const MEDIUM_LOW_FRAUD_COLOR = "#FFD700";
export const LOW_FRAUD_COLOR = "#FEF2CB"

export const COMPLETE_APPROVED_COLOR = "#28a745";
export const COMPLETE_DENIED_COLOR = "#dc3545";
export const PROCEED_PASS_COLOR = "#bcf5bc";
export const PROCEED_FAIL_COLOR = "#FFCCCC";
export const ABANDONED_COLOR = "#ADB5BD";